
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/[property]",
      function () {
        return require("private-next-pages/homes/[property].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homes/[property]"])
      });
    }
  